export const habaCatalogForm = {
  habaCatalogForm: {
    heading: 'Gratis anfordern',
    personalData: 'Wie lauten deine persönlichen Daten?',
    form: {
      title: {
        label: 'Anrede*',
        error: 'Bitte Anrede auswählen',
      },
      firstName: {
        label: 'Vorname*',
        error: 'Bitte Vorname eingeben',
      },
      lastName: {
        label: 'Nachname*',
        error: 'Bitte Nachname eingeben',
      },
      address1: {
        label: 'Straße*',
        error: 'Bitte Straße eingeben',
      },
      nr: {
        label: 'Nr*',
        error: 'Bitte Nr eingeben',
      },
      birthdate: {
        label: 'Geburtstag*',
        error: 'Bitte Geburtstag eingeben',
      },
      country: {
        label: 'Land*',
        error: 'Bitte Land auswählen',
      },
      city: {
        label: 'Ort*',
        error: 'Bitte Ort eingeben',
      },
      zipCode: {
        label: 'PLZ*',
        error: 'Bitte PLZ eingeben',
      },
      email: {
        label: 'E-Mail-Adresse*',
        error: 'Bitte E-Mail-Adresse eingeben',
      },
      submit: 'Anfordern',
    },
  },
};
